/* eslint-disable react/jsx-props-no-spreading */

import React, {FC} from 'react';

import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {Dropdown, DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';

/*
 * Props.
 */

interface TablePageSizeDropdownBoxProps {
  isLoading?: boolean;
  selectedPageSize: number;
  pageSizes?: ReadonlyArray<number>;
  onPageSizeSelect: (arg: number) => void;
}

interface TablePageSizeDropdownProps extends DropdownProps, TablePageSizeDropdownBoxProps {}

/*
 * Component.
 */

export const TablePageSizeDropdownBox: FC<TablePageSizeDropdownBoxProps> = (props) => (
  <DropdownBoxCoordinator
    value={props.selectedPageSize}
    renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
    isDisabled={props.isLoading}
  />
);

function renderDropdown(popoverProps: PopoverTransferProps, props: TablePageSizeDropdownBoxProps) {
  return <TablePageSizeDropdown {...popoverProps} {...props} width={70} />;
}

const TablePageSizeDropdown: FC<TablePageSizeDropdownProps> = (props) => (
  <Dropdown {...props}>
    <DropdownList {...props}>{renderPageSizes(props)}</DropdownList>
  </Dropdown>
);

const defaultPageSizes = [10, 20, 30, 50];

function renderPageSizes({pageSizes, onPageSizeSelect, selectedPageSize}: TablePageSizeDropdownBoxProps) {
  return (pageSizes || defaultPageSizes).map((size) => (
    <SimpleDropdownItem
      key={size}
      isChecked={selectedPageSize === size}
      onSelect={() => onPageSizeSelect(size)}
      checkmarkLabel={size}
    >
      {size}
    </SimpleDropdownItem>
  ));
}
